import { createNode } from '@glueapp/graph-types';

type HashAlgorithm = 'sha256' | 'sha512' | 'argon2';

export const HashPassword = createNode({
    id: 'HashPassword',
    name: 'Hash Password',
    description:
        'Hash a password using a selected algorithm. A random salt is always generated automatically. For Argon2, the salt is embedded in the output hash. For SHA variants, the output format is salt$hash so CheckPassword can extract and verify it.',
    category: 'API Server',
    color: '#808080',
    isAsync: true,
    interfaceComponentId: 'hash-password-algorithm',
    inPorts: {
        Password: { kind: 'string' },
    },
    outPorts: {
        Hash: { kind: 'string' },
    },
    execute: async input => {
        const password = input.inPorts.Password as string | null;
        const algorithm = (input.state?.algorithm as HashAlgorithm) || 'argon2';

        if (!password) {
            return { output: { Hash: '' } };
        }

        if (algorithm === 'argon2') {
            const argon2 = await import('argon2');
            const hash = await argon2.hash(password);
            return { output: { Hash: hash } };
        }

        // SHA-256 / SHA-512 — generate random salt, output as salt$hash
        const crypto = await import('crypto');
        const salt = crypto.randomBytes(16).toString('hex');
        const hash = crypto
            .createHash(algorithm)
            .update(salt + password)
            .digest('hex');
        return { output: { Hash: `${salt}$${hash}` } };
    },
});
